import { useContext } from "react";
import { PopoverContext } from "./PopoverContext";

/**
 * Returns the PopoverContext for use within Popover compound components.
 * @returns The current PopoverContextProps value.
 * @throws Error if called outside a Popover component.
 */
export function usePopoverContext() {
  const context = useContext(PopoverContext);
  if (!context) {
    throw new Error(
      "Popover compound components must be used within a <Popover> component.",
    );
  }
  return context;
}
